import React from 'react';
import { RELO_LOGO } from '../../constants/config';
import { User } from '@app/types/api';
import { Flex, Typography } from '@app/ui';
import { CheckOutlined } from '@ant-design/icons';

type ClientSelectionListItemProps = {
    isSelected: boolean;
    _onClick: () => void;
    client: User['clients'][number];
};

export const ClientSelectionListItem = ({
    isSelected,
    _onClick,
    client,
}: ClientSelectionListItemProps) => {
    const { name, id, headerImageUrl } = client;

    const logo = headerImageUrl ? headerImageUrl : RELO_LOGO;

    return (
        <Flex
            style={{ width: '100%' }}
            align="center"
            justify="space-between"
            key={id}
            onClick={_onClick}
            className="-p-a-2 -client-selection-item"
        >
            <Flex align="center">
                <div className="gds-account__image -m-l-1 -m-r-2">
                    <img src={logo} height="100%" width="100%" alt={name} />
                </div>
                <div
                    style={{
                        flex: '1 1 0%',
                    }}
                >
                    <Typography.Text
                        className={isSelected ? '-client-selected' : ''}
                    >
                        {name}
                    </Typography.Text>
                </div>
            </Flex>

            <div>
                {isSelected && (
                    <CheckOutlined
                        style={{ fontSize: 19, color: 'rgba(4, 128, 178, 1)' }}
                    />
                )}
            </div>
        </Flex>
    );
};
